// Version en LECTURE SEULE de useCollection, pour consulter la collection
// d'un ami (cf. section "Amis"). Volontairement plus simple : pas d'écriture
// optimiste, pas de file hors ligne — juste un GET frais à chaque changement
// d'ami consulté.
import { useState, useEffect } from "react";
import { fetchCollectionCardIds, fetchSetPreferences } from "../lib/api";

export function useFriendCollection(friendId) {
  const [collection, setCollection] = useState({});
  const [conditions, setConditions] = useState({});
  const [setPreferences, setSetPreferencesMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!friendId) return;
    let cancelled = false;
    setLoading(true);
    Promise.all([
      fetchCollectionCardIds(friendId),
      fetchSetPreferences(friendId),
    ]).then(([{ collection, conditions }, prefs]) => {
      if (cancelled) return;
      setCollection(collection);
      setConditions(conditions);
      setSetPreferencesMap(prefs);
    }).catch(err => console.error("Collection d'ami :", err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [friendId]);

  return { collection, conditions, setPreferences, loading };
}
